import { CircularProgress } from "@mui/material";
import { FC } from "react";
import { HeadingS } from "../../Typography";
import * as Styled from "./ConfirmOverlay.styled";

export type ConfirmOverlayProps = {
    title: string;
    text: string;
    confirmButtonTitle: string;
    cancelButtonTitle: string;
    confirmAction: () => Promise<void> | void;
    cancelAction: () => Promise<void> | void;
    isLoading?: boolean;
};

export const ConfirmOverlay: FC<ConfirmOverlayProps> = ({
    title,
    text,
    confirmButtonTitle,
    cancelButtonTitle,
    confirmAction,
    cancelAction,
    isLoading = false,
}) => {
    return (
        <Styled.ConfirmOverlayPaper>
            <HeadingS>{title}</HeadingS>
            <Styled.ConfirmOverlayText>{text}</Styled.ConfirmOverlayText>
            <Styled.ConfirmOverlayStack>
                {/* Cancel */}
                <Styled.ConfirmOverlayButton
                    disabled={isLoading}
                    component="button"
                    onClick={cancelAction}
                    variant="text"
                >
                    {cancelButtonTitle}
                </Styled.ConfirmOverlayButton>
                {/* Confirm */}
                <Styled.ConfirmOverlayButton
                    disabled={isLoading}
                    component="button"
                    onClick={confirmAction}
                    variant="contained"
                >
                    {isLoading ? <CircularProgress size={20} /> : confirmButtonTitle}
                </Styled.ConfirmOverlayButton>
            </Styled.ConfirmOverlayStack>
        </Styled.ConfirmOverlayPaper>
    );
};
